import { createContext, useContext } from 'react';
import type { APIError, Conversation, Message, Assistant } from '../../api/types';
import type { ChatVariant } from './types';
export interface ChatContextValue {
  conversationId?: string;
  messages: Message[];
  streamingMessage: string;
  isSending: boolean;
  isLoading: boolean;
  error?: APIError | null;
  conversations?: Conversation[];
  currentConversation?: Conversation | null;
  assistants?: Assistant[];
  currentAssistantId?: string;
  variant: ChatVariant;
}

export const ChatContext = createContext<ChatContextValue | undefined>(undefined);

export function useChatContext() {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('Chat compound components must be used within a Chat component');
  }
  return context;
}
